import React from "react";
import { Copy, Edit2, Trash2 } from "lucide-react";
import { stripHtml, truncateWords, truncateChars } from "./leadMagnetUtils";

export function getLeadMagnetColumns({ copyToClipboard, onEdit, onDelete }) {
  return [
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => (
        <div className="py-2">
          <div className="font-medium text-white text-sm text-left" title={row.title || "-"}>
            {truncateWords(row.title, 3)}
          </div>
        </div>
      ),
      minWidth: "250px",
    },
    {
      name: "Description",
      selector: (row) => stripHtml(row.description || ""),
      sortable: true,
      cell: (row) => (
        <div className="py-2">
          <div
            className="text-gray-300 text-xs text-left lead-magnet-description-wrapper"
            title={stripHtml(row.description || "")}
          >
            <div
              className="lead-magnet-description"
              dangerouslySetInnerHTML={{ __html: row.description || "" }}
            />
          </div>
        </div>
      ),
      minWidth: "200px",
    },
    {
      name: "Content URL",
      selector: (row) => row.contentUrl,
      cell: (row) => (
        <a
          href={row.contentUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-300 text-xs"
          title={row.contentUrl || "-"}
        >
          {truncateChars(row.contentUrl, 14)}
        </a>
      ),
      minWidth: "200px",
    },
    {
      name: "Lead Magnet URL",
      selector: (row) => row.lead_magnet_url,
      cell: (row) => (
        <div className="flex items-center gap-2">
          <span className="text-gray-300 text-xs" title={row.lead_magnet_url || "-"}>
            {truncateChars(row.lead_magnet_url, 14)}
          </span>
          <button
            onClick={() => copyToClipboard(row.lead_magnet_url)}
            className="p-1 hover:bg-blue-600/20 rounded transition-colors"
            title="Copy URL"
          >
            <Copy className="w-4 h-4 text-blue-400" />
          </button>
        </div>
      ),
      minWidth: "300px",
    },
    {
      name: "",
      cell: (row) => (
        <div className="flex items-center gap-2">
          <button
            className="p-1 bg-[#2563EB] text-xs flex gap-1 py-1 px-2 items-center text-white rounded transition-colors hover:bg-blue-700"
            onClick={() => onEdit(row)}
          >
            <Edit2 className="w-4 h-4" />
            Edit
          </button>
          <button
            className="p-1 bg-red-600 text-xs flex gap-1 py-1 px-2 items-center text-white rounded transition-colors hover:bg-red-700"
            onClick={() => onDelete(row.id)}
          >
            <Trash2 className="w-4 h-4" />
            Delete
          </button>
        </div>
      ),
      minWidth: "200px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
}
